import styled from '@emotion/styled';

enum VerticalAlign {
  Stretch = 'stretch',
  Center = 'center',
  Start = 'start',
  End = 'end',
  BaseLine = 'baseline',
}

enum HorizontalAlign {
  Start = 'start',
  Center = 'center',
  SpaceBetween = 'space-between',
  SpaceAround = 'space-around',
  SpaceEvenly = 'space-evenly',
  End = 'end',
  FlexStart = 'flex-start',
  FlexEnd = 'flex-end',
}

enum FlexDirection {
  Row = 'row',
  Column = 'column',
  RowReverse = 'row-reverse',
}

enum FlexWrap {
  NoWrap = 'nowrap',
  Wrap = 'wrap',
  WrapReverse = 'wrap-reverse',
}

interface FlexContainerProps {
  verticalAlign?: VerticalAlign;
  horizontalAlign?: HorizontalAlign;
  flexDirection?: FlexDirection;
  flexWrap?: FlexWrap;
  dataPendo?: string;
}

// TODO: refactor this so we can pass dataPendo as data-pendo to the div
// eslint-disable-next-line @typescript-eslint/ban-types
const FlexContainer = styled('div')<FlexContainerProps>`
  display: flex;
  ${(props) => (props.verticalAlign ? `align-items: ${props.verticalAlign};` : '')};
  ${(props) => (props.horizontalAlign ? `justify-content: ${props.horizontalAlign};` : '')};
  ${(props) => (props.flexDirection ? `flex-direction: ${props.flexDirection};` : '')};
  ${(props) => (props.flexWrap ? `flex-wrap: ${props.flexWrap};` : '')};
`;

export default FlexContainer;

export const FullHeightFlexContainer = styled(FlexContainer)`
  height: 100%;
`;

export { VerticalAlign, HorizontalAlign, FlexDirection, FlexWrap };
